export * from './baAppPicture.pipe';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/pipes/baAppPicture/index.ts